import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import React from "react";
import styled from "styled-components";
import { buttonResetStyles } from "../../../../../utils";
import { colors } from "../../../../../utils/colors";

export const Outer = styled.div`
    margin-left: -30px;
    margin-right: -30px;
    border-bottom: 1px solid ${transparentize(0.1, colors.brandMid)};

    ${breakpoints.large} {
        margin: 0;
    }
`;

export const Header = styled.button`
    ${buttonResetStyles}
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    padding: 32px;
    background-color: ${colors.brandMid};
    color: white;
    gap: 8px;
`;

export const Title = styled.div`
    font-size: 16px;
    color: ${colors.white};
    font-weight: 800;
`;

export const Distance = styled.div`
    display:block;
    margin-left: 0;
    font-size: 16px;
    color: ${colors.brandLight};

    ${breakpoints.large, breakpoints.medium} {
        display:inline-block;
        margin-left: 16px;
    }
`;

export const HeaderIcon = styled.div`
    display: flex;
    align-items: center;
`;

export const Content = styled.div`
    padding: 32px;
    background-color: #293a92;
    color: ${colors.white};

    ${breakpoints.large} {
        display: flex;
        justify-content: space-between;
    }

    .MuiList-root {
        list-style-type: disc;
        padding-left: 1rem;
    }
`;

export const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
    flex-grow: 1;
    max-width: 400px;

    gap: 8px;

    a,
    button {
        width: 100%;
    }

    ${breakpoints.large} {
        margin-top: 0;
        align-items: flex-start;
        justify-content: flex-end;

        > * {
            width: auto;
        }
    }
`;

const IconStyled = styled.div`
    margin-right: 24px;
`;

const DetailStyled = styled.div`
    max-width: 350px;

    a {
        color: ${colors.brandLight};
        font-weight: 700;
    }
`;

const IconAndDetailStyled = styled.div`
    display: flex;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const IconAndDetail: React.FC<{
    icon: React.ReactChild;
}> = ({ icon, children }) => {
    return (
        <IconAndDetailStyled>
            <IconStyled>{icon}</IconStyled>
            <DetailStyled>{children}</DetailStyled>
        </IconAndDetailStyled>
    );
};
